// frontend/src/stores/chatbot.js
import { defineStore } from 'pinia';

export const useChatbotStore = defineStore('chatbot', {
  persist: true,
  state: () => ({
    messages: [{ text: 'Hello! How can I assist you today?', isUser: false }],
    threadId: '',
    isSending: false,
  }),
  
  actions: {
    addMessage(message) {
      this.messages.push(message);
    },
    
    setMessages(messages) {
      this.messages = messages;
    },
    
    setThreadId(threadId) {
      this.threadId = threadId;
    },
    
    setIsSending(sending) {
      this.isSending = sending;
    },
    
    // Reset entire store to initial state
    resetStore() {
      this.messages = [{ text: 'Hello! How can I assist you today?', isUser: false }];
      this.threadId = '';
      this.isSending = false;
      console.log("ChatBot store has been reset to initial state");
    },
    
    // Clear all messages but keep initial greeting
    clearMessages() {
      this.messages = [{ text: 'Hello! How can I assist you today?', isUser: false }];
      this.threadId = '';
      console.log("ChatBot conversation has been cleared");
    }
  },
  
  getters: {
    hasMessages() {
      return this.messages.length > 1; // More than just the initial greeting
    },
    
    messageCount() {
      return this.messages.length;
    }
  }
});